import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Banner, BannerTextContainer, Box } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 340px;
    width: 100%;
`;

export const LegendsWrapper = styled.div`
    float: right;
    width: 235px;
    min-width: 235px;
    padding: 8px 0px 0px 18px;
    height: 100%;
`;

export const MarketSharesWrapper = styled(Box)`
    width: 100%;
    height: auto;
`;

export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    padding: 12px 12px 12px 24px;
    align-items: center;
`;

export const SizeAndGrowthContent = styled.div`
    display: flex;
`;

export const NoDataContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    align-content: center;
    height: 500px;
`;

export const StyledSwitchContainer = styled.div<{ isDisabled?: boolean }>`
    display: flex;
    color: ${({ isDisabled }) => (isDisabled ? carbon[200] : carbon[300])};
    font-size: 16px;
    line-height: 20px;
`;

export const BannerTitleContainer = styled.div<{ isDisabled?: boolean }>`
    color: ${({ isDisabled }) => (isDisabled ? carbon[200] : carbon[500])};
`;

export const BannerTitle = styled.div`
    font-family: Roboto;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 125% */
`;

export const StyledBanner = styled(Banner)<{ isDisabled?: boolean }>`
    background-color: ${({ isDisabled }) => (isDisabled ? carbon[25] : colorsPalettes.sky[100])};
    border-radius: 0;
    ${BannerTextContainer} {
        margin-left: 8px;
    }
`;

export const StyledIcon = styled(SWReactIcons)<{ isDisabled?: boolean }>`
    path {
        fill: ${({ isDisabled }) => (isDisabled ? carbon[200] : carbon[500])};
    }
`;
